export type ActionType =
  | 'SET_GENERIC_PAGES_DATA'
  | 'REQUEST_GENERIC_PAGES_DATA'
  | 'RECEIVED_GENERIC_PAGES_DATA'
  | 'ERROR_GENERIC_PAGES_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialState = {
  isFetching: true,
  data: {},
  error: {},
};

const GenericPages = (state = initialState, action: Partial<ActionProps>) => {
  switch (action.type) {
    case 'REQUEST_GENERIC_PAGES_DATA': {
      return {
        ...state,
      };
    }

    case 'RECEIVED_GENERIC_PAGES_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { ...payload },
      };
    }

    case 'ERROR_GENERIC_PAGES_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default GenericPages;
